module.exports = __webpack_public_path__ + "sin-up.png?cc23959bb94fa5c19df8fce63e58c679";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sin-up.png
// module id = 11
// module chunks = 0